(() => {
  function init(root = document) {
    root.querySelectorAll('details').forEach((details) => {
      if (details.querySelector('[role="alert"]')) details.open = true;
    });
    root.querySelectorAll('[data-address-country]').forEach((country) => {
      if (country.dataset.ready) return;
      country.dataset.ready = 'true';
      const form = country.closest('form');
      const list = form.querySelector('[data-address-provinces]');
      const selected = [...country.options].find((option) => option.value === country.dataset.default && option.dataset.provinces);
      if (selected) selected.selected = true;
      const update = () => {
        const option = country.options[country.selectedIndex];
        const provinces = JSON.parse(option.dataset.provinces || '[]');
        list.replaceChildren(...provinces.map(([value, label]) => {
          const item = document.createElement('option');
          item.value = value;
          item.label = label;
          return item;
        }));
      };
      update();
      country.addEventListener('change', () => {
        form.querySelector('[data-address-province]').value = '';
        update();
      });
    });
    if (location.hash === '#recover') {
      const recover = document.getElementById('recover');
      if (recover) recover.open = true;
    }
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('submit', (event) => {
    if (event.target.matches('[data-address-delete]') && !window.confirm('Delete this address?')) event.preventDefault();
  });
})();
